import { Input, InputNumber, Button } from 'antd';
import styled from 'styled-components';

export const DialogueWrapper = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  overflow: hidden;
  background: #ffffff;
`;

export const DialogueHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: rgba(61, 41, 105, 0.05);
  border-bottom: 1px solid #f0f0f0;
  @media only screen and (max-width: 768px) {
    width: 100%;
    position: relative;
    display: block;
    span {
      margin-right: 10px;
    }
  }
`;

export const DialogueHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  @media only screen and (max-width: 768px) {
    width: 100%;
    position: relative;
    display: block;
  }
  svg {
    font-size: 18px;
    color: #1f2430;
  }
  span {
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 30px;
    color: #1f2430;
  }
`;

export const DialogueHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  span {
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 30px;
    color: #1f2430;
  }

  .ant-switch {
    background: #3d2969;
  }

  .ant-switch-checked {
    background: #3d2969;
  }
`;

export const DialogueBody = styled.div`
  padding: 16px 20px 0 20px;
`;

export const DialogueRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  background: #ffffff;
  margin-bottom: 12px;
  transition: all 0.2s ease;

  ${props =>
    props.$isDragging &&
    `
    border-color: #3d2969;
    background: rgba(61, 41, 105, 0.05);
  `}

  &:hover {
    border-color: rgba(61, 41, 105, 0.3);
  }

  &:last-child {
    margin-bottom: 0;
  }
  .actionButtonsWrapper {
    width: auto;
    display: flex;
  }
  @media (max-width: 768px) {
    display: block;
    .dragHandle {
      width: 40px;
      height: 40px;
      float: left;
      text-align: left;
    }
    .dialogueInput {
      width: 100%;
      margin: 15px 0px;
    }
    .timeInputWrapper {
      width: 100%;
    }
    .actionButtonsWrapper {
      width: 100%;
      display: grid;
      grid-template-columns: 2fr 1fr 1fr;
      align-items: center;
      text-align: center;
    }
  }
`;

export const DragHandle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  color: #3d2969;

  &:active {
    cursor: grabbing;
  }

  svg {
    font-size: 14px;
  }
`;

export const DialogueNumber = styled.div`
  width: 40px;
  height: 40px;
  min-width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(10, 27, 57, 0.1);
  border-radius: 6px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #0a1b39;
  background: #ffffff;
`;

export const DialogueInput = styled(Input)`
  flex: 1;
  min-width: 200px;
  height: 40px;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #0a1b39;

  &:hover,
  &:focus {
    border-color: #3d2969;
  }
`;

export const TimeInputWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0px 6px 29px 0px rgba(89, 108, 148, 0.07);
`;

export const TimeInput = styled(InputNumber)`
  width: 60px;
  height: 32px;
  border: 1px solid #f0f0f0;
  border-radius: 6px 0 0 6px;
  border-right: none;

  .ant-input-number-input {
    height: 30px !important;
    line-height: 30px !important;
    text-align: center !important;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 14px;
    color: #0a1b39;
    padding: 0 !important;
  }

  .ant-input-number-handler-wrap {
    display: none;
  }

  &:hover,
  &:focus,
  &.ant-input-number-focused {
    border-color: #3d2969;
    border-right: none;
  }
`;

export const TimeUnit = styled.div`
  width: 50px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eae7f0;
  border: 1px solid #f0f0f0;
  border-left: none;
  border-radius: 0 6px 6px 0;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #0a1b39;
`;

export const ActionButton = styled(Button)`
  width: 24px;
  height: 24px;
  min-width: 24px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent !important;
  color: #1f2430;

  &:hover {
    background: transparent !important;
    color: #e65b5b;
  }

  svg {
    font-size: 16px;
  }
`;

export const AddButton = styled(Button)`
  width: 24px;
  height: 24px;
  min-width: 24px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent !important;
  color: #1f2430;

  &:hover {
    background: transparent !important;
    color: #3d2969;
  }

  svg {
    font-size: 18px;
  }
`;

export const AddDialogueButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  border: 1px dashed #eae7f0;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 12px;
  margin-bottom: 16px;

  &:hover {
    border-color: #3d2969;
  }

  svg {
    font-size: 18px;
    color: #3d2969;
  }

  span {
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    color: #3d2969;
  }
`;

export const DialogueFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  background: #f5f4f7;
  border-top: 1px solid #f0f0f0;

  .dialogue-count {
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 12px;
    line-height: 24px;
    color: #0a1b39;
  }

  .dialogue-duration {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    color: #0a1b39;

    strong {
      font-weight: 600;
    }
  }
`;

export const XmlTextArea = styled(Input.TextArea)`
  font-family:
    'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'source-code-pro', monospace;
  font-size: 13px;
  line-height: 1.6;
  border-radius: 8px;
  border: 1px solid #f0f0f0;

  &:focus,
  &:hover {
    border-color: #3d2969;
    box-shadow: none;
  }
`;

export const QuestionWrapper = styled.div`
  margin-bottom: 12px;
`;

export const FollowupContainer = styled.div`
  position: relative;
  margin-left: 40px;
  padding-left: 20px;
  margin-top: 8px;
`;

export const FollowupRow = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: 1px solid rgba(61, 41, 105, 0.15);
  border-radius: 6px;
  background: rgba(61, 41, 105, 0.02);
  margin-bottom: 8px;
  transition: all 0.2s ease;

  /* Curved L-shaped connecting line */
  &::before {
    content: '';
    position: absolute;
    left: -20px;
    top: -8px;
    width: 16px;
    height: calc(50% + 8px);
    border-left: 1px solid rgba(61, 41, 105, 0.2);
    border-bottom: 1px solid rgba(61, 41, 105, 0.2);
    border-radius: 0 0 0 12px;
  }

  ${props =>
    props.$isDragging &&
    `
    border-color: #3d2969;
    background: rgba(61, 41, 105, 0.06);
  `}

  &:hover {
    border-color: rgba(61, 41, 105, 0.3);
  }

  .actionButtonsWrapper {
    width: auto;
    display: flex;
  }

  @media (max-width: 768px) {
    display: block;

    .dragHandle {
      width: 40px;
      height: 40px;
      float: left;
      text-align: left;
    }

    .dialogueInput {
      width: 100%;
      margin: 15px 0;
    }

    .actionButtonsWrapper {
      width: 100%;
      display: grid;
      grid-template-columns: 2fr 1fr 1fr;
      align-items: center;
      text-align: center;
    }
  }
`;

export const PlayButton = styled(Button)`
  width: 24px;
  height: 24px;
  min-width: 24px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent !important;
  color: #3d2969;

  &:hover {
    background: transparent !important;
    color: #6b4fa0;
  }

  svg {
    font-size: 16px;
  }
`;

export const FollowupLabel = styled.div`
  width: 40px;
  height: 40px;
  min-width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(61, 41, 105, 0.15);
  border-radius: 6px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #3d2969;
  background: rgba(61, 41, 105, 0.03);
`;

export const QuestionContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

export const MediaPreviewInline = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: #f5f4f7;
  border-radius: 6px;
`;

export const MediaThumbInline = styled.div`
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eae7f0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  svg {
    font-size: 18px;
    color: #3d2969;
  }
`;

export const MediaInfoInline = styled.div`
  flex: 1;
  min-width: 0;

  .media-filename {
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 12px;
    color: #0a1b39;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .media-meta {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 11px;
    color: #8893a1;
  }
`;

export const MediaActionBtn = styled.button`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #8893a1;
  padding: 0;
  border-radius: 4px;

  &:hover {
    color: ${props => props.$danger ? '#e65b5b' : '#3d2969'};
    background: ${props => props.$danger ? 'rgba(230, 91, 91, 0.08)' : 'rgba(61, 41, 105, 0.08)'};
  }

  svg {
    font-size: 14px;
  }
`;
